package com.exura.features.firebase.domain.repository

import com.exura.features.firebase.domain.model.SerializableDomainModel
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import kotlinx.coroutines.flow.Flow

abstract class UserPrefixedRepository<in I: SerializableDomainModel, out O: SerializableDomainModel>(
    private val baseRepository: SerializableDomainModelRepositoryIO<I, O>,
    private val getDataPrefix: suspend () -> Result<DocumentReference>,
    private val collectionName: String,
) : PrefixedRepository<I, O> {

    override suspend fun getCollectionReference(): CollectionReference = getDataPrefix().getOrThrow().collection(collectionName)

    override suspend fun create(item: I): Result<O> {
        return baseRepository.create(item, getCollectionReference())
    }

    override suspend fun read(id: String): Result<O> =
        baseRepository.read(getCollectionReference().document(id))

    override suspend fun update(item: I, id: String): Result<O> =
        baseRepository.update(item, dest = getCollectionReference().document(id))

    override suspend fun update(item: I): Result<O> = update(
        item,
        id = item.firebaseDocId ?: throw IllegalArgumentException("Item must have a firebaseDocId for update operation"),
    )

    override suspend fun set(item: I, id: String): Result<O> =
        baseRepository.set(item, getCollectionReference().document(id))

    override suspend fun delete(id: String): Result<Boolean> =
        baseRepository.delete(getCollectionReference().document(id))

    override suspend fun list(): Flow<List<O>> =
        baseRepository.list(getCollectionReference())
}
